export const FLOATING_FORM_ITEM_CLASS = 'app-input-floating-item';

export const isValuePresent = (value: unknown): boolean => {
    if (value === undefined || value === null) {
        return false;
    }

    if (typeof value === 'string') {
        return value !== '';
    }

    if (typeof value === 'number') {
        return true;
    }

    if (Array.isArray(value)) {
        return value.length > 0;
    }

    return Boolean(value);
};
